import React from 'react'
import { useBreakpoint } from '@vtex/admin-ui'

import { ProductDetailsSectionContent } from './ProductDetailsSectionContent'
import type { NewProductPageQuery$data } from '../../__generated__/NewProductPageQuery.graphql'

type ProductDetailsSectionDesktopProps = {
  data: NewProductPageQuery$data
}

export const ProductDetailsSectionDesktop = ({
  data,
}: ProductDetailsSectionDesktopProps) => {
  const { breakpoint } = useBreakpoint()
  const isMobileOrTablet = ['mobile', 'tablet'].includes(breakpoint)

  if (isMobileOrTablet) {
    return null
  }

  return (
    <ProductDetailsSectionContent
      productDescription={data.product}
      productSpecifications={data.product}
    />
  )
}
